// ============================================================
// KACHING WEIGHT SYNC EXPERIMENT — START
// Ported as-is from "Horizon New (Dogsuppy) WS" on 2026-07-28.
// See snippets/kaching-weight-sync.liquid for the matching markup half.
// ============================================================
// @ts-nocheck
// Test scoped to the products listed in snippets/kaching-weight-sync.liquid.
// Does not touch section-selector.js or any other shared asset.
//
// The v4 weight selector is the permanent baseline for every scoped handle:
// weight sync and recommendation, with every bar visible. The A/B card
// treatments are dormant until explicitly activated; control keeps Kaching's
// original card hierarchy on top of that shared v4 baseline.
//
// The card-presentation experiment has three arms on top of that baseline:
// control does not activate anything, arm A calls activate("coverage"), and
// arm B calls activate("price-led"). QA can use the same values in
// ?kaching_weight_test=. The old value "1" remains an alias for coverage.
//
// Both card treatments stay inline — same widget, same spot — and always show
// all of Kaching's bars (the "Toon alle opties" three-bar window was removed
// 2026-10-19). See applyBarVisibilityWindow() and enterCardExperiment(). The earlier v3
// popup test (buildPopup/relocatePopupContent/
// openPopup/closePopup/enterPopupMode, etc.) is kept in the file but no
// longer called from anywhere — "el popup queda descartado para esta
// versión" — left in place rather than deleted in case a future test
// revisits it (this folder isn't git-tracked, so there'd be no way to get
// it back otherwise).
//
// Tot 10 kg / 10 tot 20 kg resolve on the normal product, the other brackets
// cross over to the GroteHond+ product (same URLs already resolved by the
// hidden switcher in blocks/new-product-weight-selector.liquid), carrying the
// chosen bracket in ?kaching_weight= so it can be preselected on the other
// side.
(function () {
    if (window.__kachingWeightSyncInit) return;
    window.__kachingWeightSyncInit = true;

    // Target pot quantity per weight bracket. Confirmed by Roald 2026-07-27:
    // the only correction needed against the Figma was 30-40kg (3 -> 2
    // potten, 90 -> 60 days) — everything else in the table matches as-is.
    var WEIGHT_TO_QUANTITY = {
        "tot-10": 1,
        "10-20": 2,
        "20-30": 2,
        "30-40": 2,
        "40-50": 3,
        "50-plus": 4
    };

    // Days of supply per single pot, by weight bracket (a bigger dog eats
    // through a pot faster). Days shown per bar = DAYS_PER_POT[weightKey] *
    // bar quantity. Values taken from the target design (2026-07-26 mockups).
    var DAYS_PER_POT = {
        "tot-10": 60,
        "10-20": 30,
        "20-30": 45,
        "30-40": 30,
        "40-50": 22,
        "50-plus": 18
    };

    // Dental Bright GroteHond+ contains 60 scoops per pot and uses a
    // product-specific dosage: 1 scoop/day at 20-30kg, 2 at 30-40kg and
    // 3 from 40kg. It therefore has three brackets instead of the four used
    // by GroteHond+ chewies.
    var DENTAL_GROTEHOND_WEIGHT_TO_QUANTITY = {
        "20-30": 1,
        "30-40": 2,
        "40-plus": 3
    };

    var DENTAL_GROTEHOND_DAYS_PER_POT = {
        "20-30": 60,
        "30-40": 30,
        "40-plus": 20
    };

    var ADVICE_BANNER_CLASS = "kaching-weight-sync__advice-banner";

    // Some products ("noffer" pages, per Roald) only have 3 deal bars
    // configured in Kaching instead of 4 — the desired quantity above isn't
    // always there to pick. Never recommend less than this many days of
    // stock; see resolveAvailableQuantity().
    var MIN_DAYS_OF_STOCK = 60;

    // JC_DO_PDP_COPY_01: a template can override the recommended course with
    // the product-information setting course_days, output as data-course-days
    // on the container only when it differs from 60. Absent (control), the two
    // constants above are used unchanged. Present, the minimum becomes that
    // many days and each bracket's desired quantity becomes the smallest pot
    // count covering it (ceil(days / DAYS_PER_POT)). At 60 days that formula
    // reproduces WEIGHT_TO_QUANTITY exactly. resolveAvailableQuantity() still
    // falls back to the largest bar when the deal has no bar big enough.
    function applyCourseDaysOverride(container) {
        var courseDays = parseInt(container.getAttribute("data-course-days"), 10);
        if (!courseDays || courseDays <= 0) return;

        MIN_DAYS_OF_STOCK = courseDays;
        Object.keys(DAYS_PER_POT).forEach(function (weightKey) {
            WEIGHT_TO_QUANTITY[weightKey] = Math.ceil(courseDays / DAYS_PER_POT[weightKey]);
        });
        Object.keys(DENTAL_GROTEHOND_DAYS_PER_POT).forEach(function (weightKey) {
            DENTAL_GROTEHOND_WEIGHT_TO_QUANTITY[weightKey] = Math.ceil(courseDays / DENTAL_GROTEHOND_DAYS_PER_POT[weightKey]);
        });
    }

    // Underscore prefix = Shopify (and this theme's own cart-products-custom.liquid,
    // verified) hides it from cart/checkout automatically. Only visible on the
    // order in Shopify admin.
    var CART_PROPERTY_KEY = "_weight_selection";

    // Brackets that correspond to the GroteHond+ product. The rest (tot-10,
    // 10-20) stay on the normal product. Same boundary the
    // Regulier/GroteHond+ switcher in blocks/new-product-weight-selector.liquid
    // used to use, just decided by the weight bracket now instead of a
    // separate button.
    var GROTEHOND_WEIGHT_KEYS = ["20-30", "30-40", "40-50", "50-plus", "40-plus"];

    var DEFAULT_WEIGHT_KEY_NORMAL = "10-20";
    var DEFAULT_WEIGHT_KEY_GROTEHOND = "20-30";
    // Tighter than before (was 200ms/20-30 attempts): same total wait budget,
    // but reacts sooner once Kaching's block actually shows up in the DOM.
    var MAX_SELECT_ATTEMPTS = 50;
    var SELECT_RETRY_MS = 80;
    var KACHING_CONFIG_STABLE_TICKS_REQUIRED = 3;
    var MAX_PLACEMENT_ATTEMPTS = 75;
    var PLACEMENT_RETRY_MS = 80;
    var QA_QUERY_PARAM = "kaching_weight_test";
    var WEIGHT_QUERY_PARAM = "kaching_weight";
    var SCROLL_QUERY_PARAM = "kaching_scroll";
    var SCROLL_HEADER_OFFSET = 120;
    var LOADER_ID = "kaching-weight-sync-loading-overlay";
    var SPECULATION_SCRIPT_ID = "kaching-weight-sync-speculation";

    var activated = false;
    var activeExperimentArm = null;
    var ARM_COVERAGE = "coverage";
    var ARM_PRICE_LED = "price-led";
    var lastKachingConfigSignature = "";
    var kachingConfigStableTicks = 0;
    var repairedKachingVariantIds = [];
    var repairedFormVariantIds = [];
    var productFormPointerGuardBound = false;

    // True once the shared v4 baseline starts — gates the bar-list treatment
    // (applyBarVisibilityWindow, see the "v4: bar visibility window"
    // section further down) inside applyWeightPresentation()'s poll loop.
    // Control and both treatments show every bar.
    var cardExperimentActive = false;

    function getKachingBlock() {
        return document.querySelector("kaching-bundles-block");
    }

    function getKachingAnchor() {
        return document.querySelector("kaching-bundle") || getKachingBlock();
    }

    function hasDentalGrotehondDosage() {
        var container = document.querySelector("[data-kaching-weight-sync]");
        return !!(container && container.getAttribute("data-dosage-profile") === "dental-grotehond");
    }

    function getTargetQuantity(weightKey) {
        var quantities = hasDentalGrotehondDosage()
            ? DENTAL_GROTEHOND_WEIGHT_TO_QUANTITY
            : WEIGHT_TO_QUANTITY;
        return quantities[weightKey];
    }

    function getDaysPerPot(weightKey) {
        var days = hasDentalGrotehondDosage()
            ? DENTAL_GROTEHOND_DAYS_PER_POT
            : DAYS_PER_POT;
        return days[weightKey];
    }

    function placeContainer(container) {
        var anchor = getKachingAnchor();
        if (!anchor || !anchor.parentNode) return false;
        if (container.nextElementSibling === anchor) {
            container.hidden = false;
            return true;
        }

        anchor.parentNode.insertBefore(container, anchor);
        container.hidden = false;
        return true;
    }

    function schedulePlacement(container, onPlaced) {
        var attempts = 0;

        var interval = setInterval(function () {
            attempts += 1;
            var placed = placeContainer(container);

            if (placed || attempts >= MAX_PLACEMENT_ATTEMPTS) {
                clearInterval(interval);
                if (placed && onPlaced) onPlaced();
            }
        }, PLACEMENT_RETRY_MS);
    }

    function shouldScrollToWidget() {
        try {
            return new URLSearchParams(window.location.search).get(SCROLL_QUERY_PARAM) === "1";
        } catch (error) {
            return false;
        }
    }

    // Only runs when we arrive here via navigateToVariant() (kaching_scroll=1
    // in the URL) — never on a fresh/direct visit or a plain Intelligems
    // activation. Jumps straight to the widget instead of leaving the visitor
    // at the top of product-information after the reload.
    function scrollToWidget(container) {
        var targetTop = container.getBoundingClientRect().top + window.scrollY - SCROLL_HEADER_OFFSET;
        window.scrollTo(0, Math.max(targetTop, 0));
    }

    function getDealBars(kachingBlock) {
        var raw = kachingBlock && kachingBlock.getAttribute("deal-block");
        if (!raw) return [];

        try {
            var parsed = JSON.parse(raw);
            return parsed.dealBars || [];
        } catch (error) {
            return [];
        }
    }

    function getDealBlock(kachingBlock) {
        var raw = kachingBlock && kachingBlock.getAttribute("deal-block");
        if (!raw) return null;

        try {
            return JSON.parse(raw);
        } catch (error) {
            return null;
        }
    }

    function normalizeShopifyId(value) {
        var normalized = String(value || "");
        var parts = normalized.split("/");
        return parts[parts.length - 1];
    }

    function getCurrentProductVariantContext() {
        var form =
            document.querySelector(".product-information product-form-component[data-product-id]") ||
            document.querySelector("[data-testid='product-information'] product-form-component[data-product-id]") ||
            document.querySelector("product-form-component[data-product-id]");
        if (!form) return null;

        var productId = normalizeShopifyId(form.getAttribute("data-product-id"));
        var formVariantId = normalizeShopifyId(
            (form.querySelector('input[name="id"]') || {}).value
        );
        var validVariantIds = [];
        var rawPrices = form.getAttribute("data-variant-prices") || "";

        try {
            validVariantIds = Object.keys(JSON.parse(rawPrices));
        } catch (error) {}

        if (!productId || !validVariantIds.length) return null;

        var productJsonVariantId = "";
        var productScripts = document.querySelectorAll("script.kaching-bundles-product[data-main='true']");

        productScripts.forEach(function (script) {
            if (productJsonVariantId) return;

            try {
                var productJson = JSON.parse(script.textContent || "{}");
                if (normalizeShopifyId(productJson.id) !== productId) return;

                var candidate = normalizeShopifyId(productJson.selectedVariantId);
                if (validVariantIds.indexOf(candidate) !== -1) productJsonVariantId = candidate;
            } catch (error) {}
        });

        var currentVariantId = validVariantIds.indexOf(formVariantId) !== -1
            ? formVariantId
            : productJsonVariantId || validVariantIds[0];

        return {
            form: form,
            productId: productId,
            formVariantId: formVariantId,
            currentVariantId: currentVariantId,
            validVariantIds: validVariantIds
        };
    }

    // The Kaching widget can restore an old selected variant after arriving
    // from a lander. Guard the actual product form as well as the automatic
    // deal-bar click: FormData is the last reliable boundary before the
    // theme/Kaching wrappers turn the request into /cart/add.js JSON.
    function repairCurrentProductFormVariant(formData) {
        var context = getCurrentProductVariantContext();
        if (!context) return false;

        var repaired = false;
        var inputs = context.form.querySelectorAll('input[name="id"]');

        inputs.forEach(function (input) {
            var variantId = normalizeShopifyId(input.value);
            if (context.validVariantIds.indexOf(variantId) !== -1) return;

            repaired = true;
            repairedFormVariantIds.push({
                source: "form",
                from: variantId,
                to: context.currentVariantId
            });
            input.value = context.currentVariantId;
        });

        if (formData && typeof formData.get === "function" && typeof formData.set === "function") {
            var formDataVariantId = normalizeShopifyId(formData.get("id"));
            if (context.validVariantIds.indexOf(formDataVariantId) === -1) {
                repaired = true;
                repairedFormVariantIds.push({
                    source: "formdata",
                    from: formDataVariantId,
                    to: context.currentVariantId
                });
                formData.set("id", context.currentVariantId);
            }
        }

        try {
            var url = new URL(window.location.href);
            var urlVariantId = normalizeShopifyId(url.searchParams.get("variant"));
            if (urlVariantId && context.validVariantIds.indexOf(urlVariantId) === -1) {
                repaired = true;
                repairedFormVariantIds.push({
                    source: "url",
                    from: urlVariantId,
                    to: context.currentVariantId
                });
                url.searchParams.set("variant", context.currentVariantId);
                window.history.replaceState(window.history.state, "", url.toString());
            }
        } catch (error) {}

        return repaired;
    }

    function bindProductFormVariantGuard() {
        var context = getCurrentProductVariantContext();
        var form = context && context.form && context.form.querySelector("form");
        if (!form) return;

        // Sections can replace the product form without reloading the page.
        // Mark the actual form rather than using one global boolean so the
        // replacement gets the same protection on shopify:section:load.
        if (!form.__kachingVariantGuardBound) {
            form.__kachingVariantGuardBound = true;

            form.addEventListener("formdata", function (event) {
                repairCurrentProductFormVariant(event.formData);
            });

            // Capture submit before <product-form-component> creates FormData.
            form.addEventListener("submit", function () {
                repairCurrentProductFormVariant();
            }, true);
        }

        // Kaching may update the hidden ID from its ATC click handler. Repair
        // immediately before that click reaches the button as an extra guard.
        if (!productFormPointerGuardBound) {
            productFormPointerGuardBound = true;
            window.addEventListener("pointerdown", function (event) {
                var button = event.target && event.target.closest
                    ? event.target.closest('button[type="submit"], button[data-kaching-atc-button]')
                    : null;
                var currentContext = getCurrentProductVariantContext();
                if (button && currentContext && currentContext.form.contains(button)) {
                    repairCurrentProductFormVariant();
                }
            }, true);
        }
    }

    function replacementVariantId(originalValue, currentVariantId) {
        if (typeof originalValue === "number") return Number(currentVariantId);
        if (String(originalValue || "").indexOf("gid://") === 0) {
            return "gid://shopify/ProductVariant/" + currentVariantId;
        }
        return currentVariantId;
    }

    // Kaching can briefly expose a stale defaultVariantsV2 mapping while its
    // product block initializes. Clicking a recommended bar during that
    // window can submit a deleted variant and surface "Invalid bundle
    // configuration" above the ATC. Wait for the attribute to settle, then
    // repair only invalid mappings that explicitly belong to the current
    // product. Gift, upsell and other-product mappings are never touched.
    function ensureKachingVariantConfigReady(kachingBlock) {
        var raw = kachingBlock && kachingBlock.getAttribute("deal-block");
        if (!raw) return false;

        if (raw !== lastKachingConfigSignature) {
            lastKachingConfigSignature = raw;
            kachingConfigStableTicks = 1;
            return false;
        }

        kachingConfigStableTicks += 1;
        if (kachingConfigStableTicks < KACHING_CONFIG_STABLE_TICKS_REQUIRED) return false;

        var dealBlock = getDealBlock(kachingBlock);
        var context = getCurrentProductVariantContext();
        var mappings = dealBlock && dealBlock.defaultVariantsV2;

        // Older/simple Kaching configurations do not expose this mapping.
        // Preserve their existing behaviour once the block is stable.
        if (!context || !Array.isArray(mappings)) return true;

        var changed = false;

        mappings.forEach(function (mapping) {
            if (normalizeShopifyId(mapping && mapping.productGID) !== context.productId) return;
            if (!Array.isArray(mapping.variantGIDs)) return;

            mapping.variantGIDs = mapping.variantGIDs.map(function (variantId) {
                var normalizedVariantId = normalizeShopifyId(variantId);
                if (context.validVariantIds.indexOf(normalizedVariantId) !== -1) return variantId;

                changed = true;
                repairedKachingVariantIds.push({
                    dealBarId: mapping.dealBarId || "",
                    from: normalizedVariantId,
                    to: context.currentVariantId
                });
                return replacementVariantId(variantId, context.currentVariantId);
            });
        });

        if (!changed) return true;

        var repairedRaw = JSON.stringify(dealBlock);
        lastKachingConfigSignature = repairedRaw;
        kachingConfigStableTicks = 0;
        kachingBlock.setAttribute("deal-block", repairedRaw);

        // Give Kaching a full observer/render cycle before selecting a bar.
        return false;
    }

    function getAvailableQuantities(kachingBlock) {
        var dealBars = getDealBars(kachingBlock);
        var quantities = [];

        dealBars.forEach(function (bar) {
            var quantity = parseInt(bar.quantity, 10);
            if (quantity && quantities.indexOf(quantity) === -1) quantities.push(quantity);
        });

        return quantities.sort(function (a, b) {
            return a - b;
        });
    }

    // Picks which quantity to actually recommend for this weight bracket on
    // THIS product. Prefers WEIGHT_TO_QUANTITY's desired value when that
    // option genuinely exists on the page. When it doesn't (a "noffer" page
    // with only 3 bars instead of 4, for example), falls back to the
    // smallest quantity that's actually available and still clears
    // MIN_DAYS_OF_STOCK days of stock — so we never recommend less supply
    // than the policy calls for just because the ideal pack is missing.
    function resolveAvailableQuantity(weightKey, availableQuantities) {
        if (!availableQuantities.length) return null;

        var desired = getTargetQuantity(weightKey);
        if (desired && availableQuantities.indexOf(desired) !== -1) return desired;

        var perPot = getDaysPerPot(weightKey);
        if (perPot) {
            for (var i = 0; i < availableQuantities.length; i++) {
                if (availableQuantities[i] * perPot >= MIN_DAYS_OF_STOCK) return availableQuantities[i];
            }
        }

        // Not even the largest available pack reaches the minimum — it's
        // still the best we can offer on this page.
        return availableQuantities[availableQuantities.length - 1];
    }

    function selectQuantity(quantity) {
        var kachingBlock = getKachingBlock();
        if (!kachingBlock) return false;

        repairCurrentProductFormVariant();

        var dealBars = getDealBars(kachingBlock);
        var targetBar = null;

        for (var i = 0; i < dealBars.length; i++) {
            if (parseInt(dealBars[i].quantity, 10) === quantity) {
                targetBar = dealBars[i];
                break;
            }
        }

        if (!targetBar) return false;
        if (!ensureKachingVariantConfigReady(kachingBlock)) return false;

        var barEl = kachingBlock.querySelector('[data-deal-bar-id="' + targetBar.id + '"]');
        var radio = barEl && barEl.querySelector('input[type="radio"]');

        if (!radio) return false;
        if (radio.checked) return true;

        radio.click();
        return true;
    }

    // NOTE ON FRAGILITY: everything below (getDealBars, .kaching-bundles__bar-subtitle,
    // .kaching-bundles__bar-container, .kaching-bundles__bar-most-popular) reaches into
    // Kaching Bundles' own rendered markup and overwrites/hides parts of it directly.
    // This is not a supported Kaching API — it's a DOM patch. If the app updates its
    // internal class names or structure, these functions degrade to silent no-ops
    // (nothing throws, the extra text/banner just stops appearing) rather than
    // breaking the page, but they will need to be re-verified against the live DOM
    // after any Kaching Bundles app update.

    // Kaching only renders .kaching-bundles__bar-subtitle at all when that
    // bar has its own "subtitle" field configured in the app (e.g. "noffer"
    // products where it's left blank) — there's nothing there to overwrite.
    // Build the line ourselves, using Kaching's own class name so it picks
    // up the app's existing styling for free.
    function ensureBarSubtitle(barEl) {
        var existing = barEl.querySelector(".kaching-bundles__bar-subtitle");
        if (existing) return existing;

        var contentLeft = barEl.querySelector(".kaching-bundles__bar-content-left");
        if (!contentLeft) return null;

        var secondLine = contentLeft.querySelector(".kaching-bundles__bar-second-line");
        if (!secondLine) {
            secondLine = document.createElement("div");
            secondLine.className = "kaching-bundles__bar-second-line";
            contentLeft.appendChild(secondLine);
        }

        var subtitleEl = document.createElement("div");
        subtitleEl.className = "kaching-bundles__bar-subtitle";
        secondLine.appendChild(subtitleEl);

        return subtitleEl;
    }

    // Overwrites (or creates, see ensureBarSubtitle) the "X per pot" subtitle
    // Kaching renders on every bar with a day-of-supply figure for the given
    // weight bracket (quantity * DAYS_PER_POT).
    function updateBarSubtitles(weightKey) {
        var perPot = getDaysPerPot(weightKey);
        var kachingBlock = getKachingBlock();
        if (!perPot || !kachingBlock) return false;

        var dealBars = getDealBars(kachingBlock);
        if (!dealBars.length) return false;

        var updatedAll = true;

        dealBars.forEach(function (bar) {
            var quantity = parseInt(bar.quantity, 10);
            if (!quantity) return;

            var barEl = kachingBlock.querySelector('[data-deal-bar-id="' + bar.id + '"]');
            var subtitleEl = barEl && ensureBarSubtitle(barEl);

            if (!subtitleEl) {
                updatedAll = false;
                return;
            }

            var subtitleText = "Voorraad voor " + quantity * perPot + " dagen";
            if (subtitleEl.textContent !== subtitleText) subtitleEl.textContent = subtitleText;
        });

        return updatedAll;
    }

    function normalizeMoneyText(text) {
        return (text || "").trim().replace(/\s+/g, " ");
    }

    function moneyNumber(text) {
        var normalized = normalizeMoneyText(text);
        if (!normalized) return NaN;

        var num = normalized.replace(/[^\d.,-]/g, "");
        if (!num) return NaN;

        var hasComma = num.indexOf(",") !== -1;
        var hasDot = num.indexOf(".") !== -1;

        if (hasComma && hasDot) {
            if (num.lastIndexOf(",") > num.lastIndexOf(".")) {
                num = num.replace(/\./g, "").replace(",", ".");
            } else {
                num = num.replace(/,/g, "");
            }
        } else if (hasComma) {
            num = num.replace(",", ".");
        }

        return parseFloat(num);
    }

    function detectMoneyFormat(text) {
        var normalized = normalizeMoneyText(text);
        var symbolMatch = normalized.match(/[^\d\s.,-]/);
        var numeric = normalized.replace(/[^\d.,-]/g, "");
        var usesCommaDecimal = false;

        if (numeric.indexOf(",") !== -1 && numeric.indexOf(".") !== -1) {
            usesCommaDecimal = numeric.lastIndexOf(",") > numeric.lastIndexOf(".");
        } else {
            usesCommaDecimal = numeric.indexOf(",") !== -1;
        }

        return {
            symbol: symbolMatch ? symbolMatch[0] : "€",
            usesCommaDecimal: usesCommaDecimal
        };
    }

    function formatMoney(value, sampleText) {
        if (!Number.isFinite(value)) return "";

        var format = detectMoneyFormat(sampleText);
        var fixed = value.toFixed(2);
        return format.symbol + (format.usesCommaDecimal ? fixed.replace(".", ",") : fixed);
    }

    function getBarTotalPrice(barEl, quantity, dealBlock) {
        var priceEl = barEl && barEl.querySelector(".kaching-bundles__bar-price");
        if (!priceEl) return null;

        var storedValue = parseFloat(priceEl.getAttribute("data-kaching-weight-total-value"));
        var storedText = priceEl.getAttribute("data-kaching-weight-total-text");
        var hasOurPriceMarkup = !!priceEl.querySelector(".kaching-weight-card__daily-price");
        if (hasOurPriceMarkup && Number.isFinite(storedValue) && storedText) {
            return { value: storedValue, text: storedText };
        }

        var rawText = normalizeMoneyText(priceEl.textContent);
        var rawValue = moneyNumber(rawText);
        if (!Number.isFinite(rawValue)) return null;

        var totalValue = dealBlock && dealBlock.showPricesPerItem === true && quantity > 1
            ? +(rawValue * quantity).toFixed(2)
            : rawValue;
        var totalText = formatMoney(totalValue, rawText);

        priceEl.setAttribute("data-kaching-weight-total-value", String(totalValue));
        priceEl.setAttribute("data-kaching-weight-total-text", totalText);
        return { value: totalValue, text: totalText };
    }

    function updateExperimentCards(container, weightKey) {
        if (!activeExperimentArm) return true;
        if (!container) return false;

        var perPot = getDaysPerPot(weightKey);
        var unitsPerPot = parseInt(container.getAttribute("data-units-per-pot"), 10);
        var unitLabel = container.getAttribute("data-unit-label") || "chewies";
        var kachingBlock = getKachingBlock();
        var dealBlock = getDealBlock(kachingBlock);
        var dealBars = dealBlock && dealBlock.dealBars;

        if (!perPot || !unitsPerPot || !kachingBlock || !dealBars || !dealBars.length) return false;

        kachingBlock.classList.add("kaching-weight-card-treatment");

        var updatedAll = true;

        dealBars.forEach(function (bar) {
            var quantity = parseInt(bar.quantity, 10);
            var barEl = kachingBlock.querySelector('[data-deal-bar-id="' + bar.id + '"]');
            var titleEl = barEl && barEl.querySelector(".kaching-bundles__bar-title");
            var subtitleEl = barEl && ensureBarSubtitle(barEl);

            if (!quantity || !barEl || !titleEl || !subtitleEl) {
                updatedAll = false;
                return;
            }

            var days = quantity * perPot;
            var titleText = "Voorraad voor " + days + " dagen";
            var subtitleText =
                quantity + " " + (quantity === 1 ? "pot" : "potten") +
                " · " + quantity * unitsPerPot + " " + unitLabel;
            if (titleEl.textContent !== titleText) titleEl.textContent = titleText;
            if (subtitleEl.textContent !== subtitleText) subtitleEl.textContent = subtitleText;
            barEl.setAttribute("data-kaching-weight-card-arm", activeExperimentArm);
            shortenDiscountBadge(barEl);

            if (activeExperimentArm !== ARM_PRICE_LED) return;

            var priceEl = barEl.querySelector(".kaching-bundles__bar-price");
            var totalPrice = getBarTotalPrice(barEl, quantity, dealBlock);
            if (!priceEl || !totalPrice || !days) {
                updatedAll = false;
                return;
            }

            var dailyText = formatMoney(totalPrice.value / days, totalPrice.text);
            var priceMarkup =
                '<span class="kaching-weight-card__daily-price">' + dailyText + ' per dag</span>' +
                '<span class="kaching-weight-card__total-price">' + totalPrice.text + ' totaal</span>';
            if (priceEl.innerHTML !== priceMarkup) priceEl.innerHTML = priceMarkup;
        });

        return updatedAll;
    }

    // Kaching owns the discount badge markup and does not expose a stable
    // public selector for it. Change only the deepest element whose complete
    // visible text matches "Tijdelijk -X%", preserving the live percentage and
    // leaving every other piece of Kaching copy untouched.
    function shortenDiscountBadge(barEl) {
        var candidates = Array.prototype.slice.call(barEl.querySelectorAll("*"));

        candidates.forEach(function (element) {
            var match = normalizeMoneyText(element.textContent).match(/^Tijdelijk\s+(-?\s*\d+(?:[.,]\d+)?%)$/i);
            if (!match) return;

            var matchingChild = Array.prototype.some.call(element.children, function (child) {
                return /^Tijdelijk\s+(-?\s*\d+(?:[.,]\d+)?%)$/i.test(normalizeMoneyText(child.textContent));
            });

            if (!matchingChild) {
                element.classList.add("kaching-weight-card__discount-badge");
                element.textContent = match[1].replace(/\s+/g, "");
            }
        });
    }

    // "Tot 10 kg" -> "tot 10 kg" (no "van"), "Vanaf 50 kg" -> "vanaf 50 kg" (no
    // "van"), "10 tot 20 kg" -> "van 10 tot 20 kg". Reads straight off the
    // button's own visible label so the phrasing never drifts from what's on
    // screen in the selector above.
    function buildAdviceText(weightLabel) {
        var lower = (weightLabel || "").trim().toLowerCase();
        if (!lower) return "";

        if (lower.indexOf("tot") === 0 || lower.indexOf("vanaf") === 0) {
            return "Ons advies voor jouw hond " + lower;
        }

        return "Ons advies voor jouw hond van " + lower;
    }

    // Moves our own "Ons advies..." banner to the top of the bar matching the
    // current weight's recommended quantity, replacing Kaching's native
    // "Meest gekozen" / "Meeste voordeel" badge slot (hidden via CSS while the
    // test is active — see `{% stylesheet %}` in kaching-weight-sync.liquid).
    function placeAdviceBanner(weightKey, weightLabel, quantity) {
        var kachingBlock = getKachingBlock();
        if (!quantity || !kachingBlock) return false;

        var dealBars = getDealBars(kachingBlock);
        var targetBar = null;

        for (var i = 0; i < dealBars.length; i++) {
            if (parseInt(dealBars[i].quantity, 10) === quantity) {
                targetBar = dealBars[i];
                break;
            }
        }

        if (!targetBar) return false;

        var barEl = kachingBlock.querySelector('[data-deal-bar-id="' + targetBar.id + '"]');
        var label = barEl && barEl.querySelector(".kaching-bundles__bar-container");
        if (!label) return false;

        var text = buildAdviceText(weightLabel);
        var existing = label.querySelector(":scope > ." + ADVICE_BANNER_CLASS);

        if (existing) {
            if (existing.textContent !== text) existing.textContent = text;
        } else {
            document.querySelectorAll("." + ADVICE_BANNER_CLASS).forEach(function (el) {
                el.remove();
            });

            var banner = document.createElement("div");
            banner.className = ADVICE_BANNER_CLASS;
            banner.textContent = text;
            label.insertBefore(banner, label.firstChild);
        }

        return true;
    }

    // ------------------------------------------------------------------
    // Bar visibility: every Kaching bar is always shown. The earlier v4
    // three-bar window with a "Toon alle opties" link was removed at
    // Roald's request (2026-10-19). This still un-hides any bar a previous
    // version of the window may have hidden and drops a stray link.
    // ------------------------------------------------------------------
    var EXPAND_LINK_CLASS = "kaching-weight-sync__expand-link";

    function applyBarVisibilityWindow() {
        var existingLink = document.querySelector("." + EXPAND_LINK_CLASS);
        if (existingLink) existingLink.remove();

        var kachingBlock = getKachingBlock();
        if (!kachingBlock) return;

        getDealBars(kachingBlock).forEach(function (bar) {
            var barEl = kachingBlock.querySelector('[data-deal-bar-id="' + bar.id + '"]');
            if (barEl && barEl.style.display === "none") barEl.style.display = "";
        });
    }

    // Only one weight can legitimately be "in progress" at a time — without
    // this, clicking a new bracket while the previous applyWeightPresentation
    // poll loop was still settling (e.g. right after the initial default on
    // page load) left two intervals racing each other, each repeatedly
    // re-selecting its own quantity/banner every tick. That's the flicker.
    var activeWeightInterval = null;

    function applyWeightPresentation(weightKey, weightLabel) {
        if (!getTargetQuantity(weightKey)) return;

        if (activeWeightInterval) {
            clearInterval(activeWeightInterval);
            activeWeightInterval = null;
        }

        currentWeightLabel = (weightLabel || "").trim();

        var attempts = 0;

        activeWeightInterval = setInterval(function () {
            attempts += 1;

            var kachingBlock = getKachingBlock();
            var availableQuantities = kachingBlock ? getAvailableQuantities(kachingBlock) : [];
            var quantity = resolveAvailableQuantity(weightKey, availableQuantities);

            var selected = quantity ? selectQuantity(quantity) : false;
            // Treatments replace the subtitle with quantity + units inside
            // updateExperimentCards(). Running both writers would alternate
            // the text and keep the Kaching observer firing indefinitely.
            var subtitlesUpdated = activeExperimentArm ? true : updateBarSubtitles(weightKey);
            var bannerPlaced = quantity ? placeAdviceBanner(weightKey, weightLabel, quantity) : false;
            var cardsUpdated = updateExperimentCards(document.querySelector("[data-kaching-weight-sync]"), weightKey);

            if (cardExperimentActive) applyBarVisibilityWindow(weightKey);

            if ((selected && subtitlesUpdated && bannerPlaced && cardsUpdated) || attempts >= MAX_SELECT_ATTEMPTS) {
                clearInterval(activeWeightInterval);
                activeWeightInterval = null;
            }
        }, SELECT_RETRY_MS);
    }

    function setActiveButton(container, activeButton) {
        var buttons = container.querySelectorAll("[data-weight-key]");

        buttons.forEach(function (button) {
            var isActive = button === activeButton;
            button.classList.toggle("is-active", isActive);
            button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
    }

    // The "Regulier / GroteHond+" selector (blocks/new-product-weight-selector.liquid)
    // becomes redundant with our 6-bracket selector. Only hidden when the
    // test is active; the control group keeps seeing it as always.
    function hideLegacyWeightSelector() {
        var legacy = document.querySelector(".new-product-selector-cont");
        if (legacy) legacy.hidden = true;
    }

    function isGrotehondWeight(weightKey) {
        return GROTEHOND_WEIGHT_KEYS.indexOf(weightKey) !== -1;
    }

    function normalizeExperimentArm(arm) {
        var normalized = String(arm || "").trim().toLowerCase();
        if (normalized === "1" || normalized === "a" || normalized === ARM_COVERAGE) return ARM_COVERAGE;
        if (normalized === "b" || normalized === "price_led" || normalized === ARM_PRICE_LED) return ARM_PRICE_LED;
        return null;
    }

    function getQaArm() {
        try {
            return normalizeExperimentArm(new URLSearchParams(window.location.search).get(QA_QUERY_PARAM));
        } catch (error) {
            return null;
        }
    }

    function getWeightFromUrl() {
        try {
            return new URLSearchParams(window.location.search).get(WEIGHT_QUERY_PARAM);
        } catch (error) {
            return null;
        }
    }

    function buildVariantUrl(baseUrl, weightKey) {
        var url;
        try {
            url = new URL(baseUrl, window.location.origin);
        } catch (error) {
            return null;
        }

        // weightKey is optional: the GroteHond+ modal / direct cross-link
        // aren't tied to a specific bracket, so the destination just falls
        // back to its own default weight.
        if (weightKey) url.searchParams.set(WEIGHT_QUERY_PARAM, weightKey);
        url.searchParams.set(SCROLL_QUERY_PARAM, "1");
        // QA override continuity across products: if this session is already
        // in manual test mode, keep it when crossing over to the other product.
        var qaArm = getQaArm();
        if (qaArm) url.searchParams.set(QA_QUERY_PARAM, qaArm);

        return url.toString();
    }

    function showNavigationLoader() {
        if (document.getElementById(LOADER_ID)) return;

        var overlay = document.createElement("div");
        overlay.id = LOADER_ID;
        overlay.setAttribute("aria-hidden", "true");
        overlay.style.cssText =
            "position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;" +
            "background:rgba(0,0,0,0.28);";

        var spinner = document.createElement("div");
        spinner.style.cssText =
            "width:40px;height:40px;border-radius:9999px;border:4px solid rgba(255,255,255,0.35);" +
            "border-top-color:#fff;animation:kaching-weight-sync-spin 800ms linear infinite;";
        overlay.appendChild(spinner);

        if (!document.getElementById(LOADER_ID + "-style")) {
            var style = document.createElement("style");
            style.id = LOADER_ID + "-style";
            style.textContent =
                "@keyframes kaching-weight-sync-spin { to { transform: rotate(360deg); } }";
            document.head.appendChild(style);
        }

        document.body.appendChild(overlay);
    }

    // Warms the browser cache for the other product as soon as the widget
    // activates, so the eventual full-page navigation in navigateToVariant()
    // (triggered by a click on a crossing bracket) resolves near-instantly
    // instead of a slow, visibly blank reload. Doesn't change navigation
    // behavior at all — just a <link rel="prefetch"> hint, safe to no-op on
    // browsers that ignore it.
    function prefetchVariantUrl(targetUrl) {
        if (!targetUrl) return;
        if (document.querySelector('link[rel="prefetch"][href="' + targetUrl + '"]')) return;

        var link = document.createElement("link");
        link.rel = "prefetch";
        link.href = targetUrl;
        document.head.appendChild(link);
    }

    // Progressive enhancement on top of prefetch: on browsers that support the
    // Speculation Rules API (Chrome/Edge), this actually renders the target
    // page in a hidden background tab, so navigateToVariant() below can feel
    // close to instant instead of just "faster". No-ops silently everywhere
    // else (Safari/Firefox), where prefetch alone still applies.
    function prerenderVariantUrl(targetUrl) {
        if (!targetUrl) return;
        if (typeof HTMLScriptElement === "undefined" || !HTMLScriptElement.supports) return;
        if (!HTMLScriptElement.supports("speculationrules")) return;
        if (document.getElementById(SPECULATION_SCRIPT_ID)) return;

        var script = document.createElement("script");
        script.type = "speculationrules";
        script.id = SPECULATION_SCRIPT_ID;
        script.textContent = JSON.stringify({
            prerender: [{ urls: [targetUrl], eagerness: "moderate" }]
        });
        document.head.appendChild(script);
    }

    // Kaching Bundles adds to cart through its own request, not the theme's
    // normal product form — a plain hidden <input properties[...]> would
    // never reach it. Own copy of the same fetch/XHR interception approach
    // section-selector.js already uses for a different purpose (variant-id
    // correction); this one only injects the weight property and never
    // touches that file.
    var currentWeightLabel = null;

    function isCartAddUrl(url) {
        if (!url) return false;

        try {
            var parsed = new URL(url, window.location.origin);
            return /\/cart\/add(\.js)?$/i.test(parsed.pathname);
        } catch (error) {
            return /\/cart\/add(\.js)?$/i.test(url);
        }
    }

    function injectWeightProperty(body) {
        if (!currentWeightLabel) return body;

        if (body instanceof FormData) {
            body.set("properties[" + CART_PROPERTY_KEY + "]", currentWeightLabel);
            return body;
        }

        if (body instanceof URLSearchParams) {
            body.set("properties[" + CART_PROPERTY_KEY + "]", currentWeightLabel);
            return body;
        }

        if (typeof body === "string" && body.trim().indexOf("{") === 0) {
            try {
                var json = JSON.parse(body);
                json.properties = json.properties || {};
                json.properties[CART_PROPERTY_KEY] = currentWeightLabel;
                return JSON.stringify(json);
            } catch (error) {
                return body;
            }
        }

        return body;
    }

    function bindCartPropertyInjector() {
        if (window.__kachingWeightSyncCartBound) return;
        window.__kachingWeightSyncCartBound = true;

        var originalFetch = window.fetch;

        window.fetch = function () {
            var args = Array.prototype.slice.call(arguments);
            var resource = args[0];
            var url = typeof resource === "string" ? resource : resource && resource.url;
            var isAdd = isCartAddUrl(url);

            if (isAdd && args[1] && args[1].body) {
                var nextInit = Object.assign({}, args[1]);
                nextInit.body = injectWeightProperty(args[1].body);
                args[1] = nextInit;
            }

            var result = originalFetch.apply(this, args);

            // Popup mode only (2026-08-06 feedback): close our popup once
            // the item is actually added, so it doesn't sit open behind
            // the cart drawer that opens on top of it. closePopupOnCartAdd()
            // already no-ops when there's no popup (control/baseline) or
            // it's not open, so this is harmless everywhere else.
            if (isAdd && result && typeof result.then === "function") {
                result.then(function (response) {
                    if (response && response.ok) closePopupOnCartAdd();
                }, function () {});
            }

            return result;
        };

        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
            this.__kachingWeightSyncCartUrl = url;
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function (body) {
            var isAdd = isCartAddUrl(this.__kachingWeightSyncCartUrl);
            var nextBody = isAdd ? injectWeightProperty(body) : body;

            if (isAdd) {
                this.addEventListener("load", function () {
                    if (this.status >= 200 && this.status < 300) closePopupOnCartAdd();
                });
            }

            return originalSend.call(this, nextBody);
        };
    }

    // Crosses over between products (normal <-> GroteHond+) reusing the URLs
    // already resolved by blocks/new-product-weight-selector.liquid via the
    // pdp_config metafield. Carries the chosen bracket in the URL so it can
    // be preselected on the other side (see getWeightFromUrl in boot()).
    function navigateToVariant(targetUrl, weightKey) {
        if (!targetUrl) return false;

        var url = buildVariantUrl(targetUrl, weightKey);
        if (!url) return false;

        showNavigationLoader();
        window.location.href = url;
        return true;
    }

    // The GroteHond+ upsell modal only exists on the normal product's markup
    // (see the {% unless kaching_weight_sync_is_grotehond %} block around
    // [data-kaching-grotehond-modal] in the snippet) — on the GroteHond+ side
    // this query simply finds nothing, and every function below is a no-op.
    function getGrotehondModal() {
        return document.querySelector("[data-kaching-grotehond-modal]");
    }

    function openGrotehondModal() {
        var modal = getGrotehondModal();
        if (modal) modal.hidden = false;
    }

    function closeGrotehondModal() {
        var modal = getGrotehondModal();
        if (modal) modal.hidden = true;
    }

    // Wires the "Shop GroteHond+ →" link (opens the modal instead of
    // navigating directly), the modal's own confirm CTA (navigates for
    // real, through navigateToVariant so it gets the loader + prefetch
    // benefits), and every dismiss control (X, backdrop, "Blijf op ...
    // regulier", Escape key).
    function bindGrotehondModal(container) {
        var openTrigger = container.querySelector("[data-kaching-open-grotehond-modal]");
        if (openTrigger) {
            openTrigger.addEventListener("click", function (event) {
                event.preventDefault();
                openGrotehondModal();
            });
        }

        var modal = getGrotehondModal();
        if (!modal) return;

        // The snippet renders the modal inline, wherever that happens to
        // land in the DOM — once the widget itself gets moved next to
        // <kaching-bundle> (see schedulePlacement), that spot can end up
        // inside a `transform`d ancestor (the sticky product-details
        // column), which breaks `position: fixed`. Move it under <body>
        // unconditionally so it never depends on that coincidence.
        if (modal.parentNode !== document.body) {
            document.body.appendChild(modal);
        }

        modal.querySelectorAll("[data-kaching-modal-close]").forEach(function (el) {
            el.addEventListener("click", function (event) {
                event.preventDefault();
                closeGrotehondModal();
            });
        });

        var confirmLink = modal.querySelector("[data-kaching-modal-confirm]");
        if (confirmLink) {
            confirmLink.addEventListener("click", function (event) {
                event.preventDefault();
                // No specific weightKey: the visitor confirmed "I want
                // GroteHond+" generally, not any one bracket — the
                // destination just falls back to its own default.
                navigateToVariant(confirmLink.getAttribute("href"), null);
            });
        }

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && !modal.hidden) closeGrotehondModal();
        });
    }

    // Activates the CSS from assets/kaching-weight-sync.js (see `{% stylesheet %}`
    // in snippets/kaching-weight-sync.liquid), which is scoped under this
    // class so it never affects any PDP outside the test.
    var ACTIVE_BODY_CLASS = "kaching-weight-sync-active";

    // Idempotent so repeated activation/lifecycle events cannot duplicate
    // interaction handlers.
    function bindContainerInteractions(container) {
        if (container.__kachingInteractionsBound) return;
        container.__kachingInteractionsBound = true;

        var isGrotehond = container.getAttribute("data-is-grotehond") === "true";
        var normalUrl = container.getAttribute("data-normal-url");
        var grotehondUrl = container.getAttribute("data-grotehond-url");
        var crossUrl = isGrotehond ? normalUrl : grotehondUrl;

        prefetchVariantUrl(crossUrl);
        prerenderVariantUrl(crossUrl);

        // The GroteHond+ -> regular link is rendered as an anchor. Route it
        // through the same navigation helper as the modal CTA so QA arm and
        // scroll continuity are preserved in both directions.
        var directCrossLink = container.querySelector("[data-kaching-cross-link-direct]");
        if (directCrossLink) {
            directCrossLink.addEventListener("click", function (event) {
                event.preventDefault();
                navigateToVariant(directCrossLink.getAttribute("href"), null);
            });
        }

        // v2's buttons only ever render same-side brackets (2 for the normal
        // product, 4 for GroteHond+), so weightIsGrotehond !== isGrotehond
        // never actually fires for a real click anymore — crossing over
        // happens through the separate cross-link/modal instead. Left in
        // place as a safety net (e.g. a future version that mixes brackets
        // again) rather than something reachable today. Delegated on the
        // container itself so it keeps working regardless of what
        // repopulates its buttons later.
        container.addEventListener("click", function (event) {
            var button = event.target.closest("[data-weight-key]");
            if (!button || !container.contains(button)) return;

            var weightKey = button.getAttribute("data-weight-key");
            var weightIsGrotehond = isGrotehondWeight(weightKey);

            if (weightIsGrotehond !== isGrotehond) {
                var targetUrl = weightIsGrotehond ? grotehondUrl : normalUrl;
                if (navigateToVariant(targetUrl, weightKey)) return;
                // No URL configured for the other product (empty metafield):
                // stay on the current page instead of doing nothing.
            }

            setActiveButton(container, button);
            applyWeightPresentation(weightKey, button.textContent);
        });
    }

    function applyDefaultWeight(container) {
        var isGrotehond = container.getAttribute("data-is-grotehond") === "true";
        var urlWeightKey = getWeightFromUrl();
        var fallbackKey = isGrotehond ? DEFAULT_WEIGHT_KEY_GROTEHOND : DEFAULT_WEIGHT_KEY_NORMAL;
        var initialKey =
            urlWeightKey && getTargetQuantity(urlWeightKey) && isGrotehondWeight(urlWeightKey) === isGrotehond
                ? urlWeightKey
                : fallbackKey;

        var defaultButton = container.querySelector('[data-weight-key="' + initialKey + '"]');
        if (defaultButton) {
            setActiveButton(container, defaultButton);
            applyWeightPresentation(initialKey, defaultButton.textContent);
        }
    }

    // placeContainer only confirms <kaching-bundle> exists in the DOM, not
    // that it has actually rendered its bars yet — scrolling as soon as it's
    // merely present jumps to the right spot while Kaching is still an empty
    // shell, showing a flash of whatever page content happens to be there
    // instead. Wait for real bars before scrolling.
    function scrollWhenKachingReady(container) {
        var attempts = 0;

        var interval = setInterval(function () {
            attempts += 1;

            var kachingBlock = getKachingBlock();
            var ready = !!(kachingBlock && getDealBars(kachingBlock).length);

            if (ready || attempts >= MAX_PLACEMENT_ATTEMPTS) {
                clearInterval(interval);

                scrollToWidget(container);
                // Late layout shifts (lazy images, webfonts) can still push
                // the widget down right after — correct once more shortly after.
                setTimeout(function () {
                    scrollToWidget(container);
                }, 300);
            }
        }, PLACEMENT_RETRY_MS);
    }

    function schedulePlacementAndScroll(container) {
        schedulePlacement(container, function () {
            if (!shouldScrollToWidget()) return;
            scrollWhenKachingReady(container);
        });
    }

    // Everything the shared baseline and activated experiment arms need:
    // body class, hiding the
    // legacy Regulier/GroteHond+ switcher, the
    // cart property injector, click binding, the GroteHond+ modal, and an
    // initial weight. Guarded so it only actually runs once.
    var baseSetupStarted = false;

    function ensureBaseSetup(container) {
        if (baseSetupStarted) return;
        baseSetupStarted = true;

        document.body.classList.add(ACTIVE_BODY_CLASS);
        hideLegacyWeightSelector();
        bindCartPropertyInjector();
        bindContainerInteractions(container);
        bindGrotehondModal(container);
        applyDefaultWeight(container);
    }

    // Rolled-out v4 baseline shared by control, A and B. It activates the
    // selector and three-option window without changing the card hierarchy.
    function runV4Baseline(container) {
        cardExperimentActive = true;
        ensureBaseSetup(container);
        schedulePlacementAndScroll(container);
        reapplyActiveWeightSelection(container);

        var observerAttempts = 0;
        var observerInterval = setInterval(function () {
            observerAttempts += 1;
            bindExperimentObserver(container);
            if (experimentObserver || observerAttempts >= MAX_PLACEMENT_ATTEMPTS) clearInterval(observerInterval);
        }, PLACEMENT_RETRY_MS);
    }

    // ------------------------------------------------------------------
    // Popup mode from the discarded 2026-08-06 redesign brief. It remains
    // dormant and is not part of the current experiment.
    //
    // Moves — never clones — the real, already-bound widget/Kaching
    // widget/benefits block/buy-buttons-block into a bottom-sheet (mobile)
    // / centered modal (desktop) opened from the sticky "Kies je pakket"
    // button, instead of leaving that content inline and scrolling to it.
    // Moving the real nodes as one intact subtree each (not copies) means
    // every existing binding — Kaching's own script, the theme's
    // <product-form-component>/add-to-cart <form>, our own click/cart-
    // property handlers — keeps working exactly as before; nothing needs
    // to be rewired just because its container moved.
    // ------------------------------------------------------------------
    var POPUP_OPEN_BODY_CLASS = "kaching-weight-popup-open";
    var STICKY_CTA_SELECTOR = "[data-scroll-to-product-information]";
    var POPUP_CLOSE_TRANSITION_MS = 350;

    var popupEl = null;

    function buildPopup() {
        if (popupEl) return popupEl;

        var template = document.querySelector("[data-kaching-popup-shell]");
        if (!template) return null;

        var fragment = template.content.cloneNode(true);
        popupEl = fragment.querySelector("[data-kaching-popup]");

        // Same reasoning as the GroteHond+ modal (see bindGrotehondModal):
        // lives directly under <body> so `position: fixed` is never
        // confined by a `transform`d ancestor.
        document.body.appendChild(popupEl);
        template.remove();

        popupEl.querySelectorAll("[data-kaching-popup-close]").forEach(function (el) {
            el.addEventListener("click", function (event) {
                event.preventDefault();
                closePopup();
            });
        });

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && popupEl && !popupEl.hidden) closePopup();
        });

        var body = popupEl.querySelector("[data-kaching-popup-body]");
        var indicator = popupEl.querySelector("[data-kaching-popup-scroll-indicator]");

        if (body && indicator) {
            var updateIndicator = function () {
                var hasMore = body.scrollHeight - body.scrollTop - body.clientHeight > 12;
                indicator.hidden = !hasMore;
            };

            body.addEventListener("scroll", updateIndicator, { passive: true });
            window.addEventListener("resize", updateIndicator);
            popupEl.__kachingUpdateScrollIndicator = updateIndicator;
        }

        return popupEl;
    }

    // Re-applies whatever weight bracket is currently active once the
    // widget lands in the popup — Kaching (and possibly
    // <product-form-component>) may re-run its own init when reconnected
    // in a new spot in the DOM, which could reset its bar selection back
    // to its own default.
    function reapplyActiveWeightSelection(container) {
        var activeButton = container.querySelector("[data-weight-key].is-active");
        if (!activeButton) return;

        applyWeightPresentation(activeButton.getAttribute("data-weight-key"), activeButton.textContent);
    }

    // Rebuilds only the visual treatment after Kaching changes its DOM. It
    // deliberately does not call selectQuantity(): a visitor's manual pack
    // choice must remain selected instead of snapping back to the advised bar.
    function refreshExperimentPresentation(container) {
        var activeButton = container.querySelector("[data-weight-key].is-active");
        if (!activeButton) return;

        var weightKey = activeButton.getAttribute("data-weight-key");
        var weightLabel = activeButton.textContent;
        var kachingBlock = getKachingBlock();
        var availableQuantities = kachingBlock ? getAvailableQuantities(kachingBlock) : [];
        var advisedQuantity = resolveAvailableQuantity(weightKey, availableQuantities);

        if (activeExperimentArm) {
            updateExperimentCards(container, weightKey);
        } else {
            updateBarSubtitles(weightKey);
        }
        if (advisedQuantity) placeAdviceBanner(weightKey, weightLabel, advisedQuantity);
        if (cardExperimentActive) applyBarVisibilityWindow(weightKey);
    }

    // Kaching can replace the contents of its bars after selection or price
    // updates. Reapply only the active treatment after those mutations settle;
    // the text writes above are idempotent, so our own mutations stop after one
    // observer pass instead of creating a loop.
    var experimentObserver = null;
    var experimentRefreshTimer = null;

    function bindExperimentObserver(container) {
        if (experimentObserver || typeof MutationObserver === "undefined") return;

        var kachingBlock = getKachingBlock();
        if (!kachingBlock) return;

        experimentObserver = new MutationObserver(function () {
            clearTimeout(experimentRefreshTimer);
            experimentRefreshTimer = setTimeout(function () {
                refreshExperimentPresentation(container);
            }, 50);
        });

        experimentObserver.observe(kachingBlock, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["deal-block"]
        });
    }

    // sections/product-information.liquid's own sticky-bar script (the
    // inline <script> right after <sticky-add-to-cart> in that file — not
    // something we touch) decides when to show the sticky "Kies je pakket"
    // bar by measuring .buy-buttons-block's position on scroll
    // (getBuyButtonsTarget() -> getBoundingClientRect()). Once we move the
    // real .buy-buttons-block into the popup (display:none while closed),
    // that measurement always returns an all-zero rect, so the sticky bar
    // never appears — the exact bug reported after the first version of
    // this. Leaving an invisible marker with the same class in the
    // original spot gives that shared script the same position to measure
    // again, with zero changes to that file: getBuyButtonsTarget()'s first
    // two querySelectors are scoped to .product-information / [data-testid
    // ="product-information"], which only the marker still matches once
    // the real block lives under <body> inside the popup.
    function leaveBuyButtonsPlaceholder(buyButtons) {
        var placeholder = document.createElement("span");
        placeholder.className = "buy-buttons-block";
        placeholder.setAttribute("data-kaching-popup-buy-buttons-placeholder", "");
        placeholder.setAttribute("aria-hidden", "true");
        placeholder.style.cssText = "display:block;height:0;margin:0;padding:0;overflow:hidden;visibility:hidden;";

        buyButtons.parentNode.insertBefore(placeholder, buyButtons);
    }

    // Popup-only rearrangement inside the moved .buy-buttons-block (2026-08-
    // 06 feedback): the Klarna icon+line (".new-button-footer", static —
    // see blocks/new-button-footer.liquid) moves into the benefits card
    // instead of sitting under the button, and the countdown
    // (".new-product-countdown", see blocks/new-product-countdown.liquid —
    // its #countdown-message timer keeps ticking after the move, same
    // reasoning as everything else here: same node, same id, just a new
    // parent) moves from above the button to below it. Doesn't touch
    // blocks/new-button-footer.liquid, blocks/new-product-countdown.liquid,
    // or blocks/buy-buttons.liquid — the default inline page (and every
    // non-popup visitor) keeps their original order untouched.
    function rearrangeBuyButtonsForPopup(buyButtons, benefits) {
        var buttonFooter = buyButtons.querySelector(".new-button-footer");
        if (buttonFooter && benefits) benefits.appendChild(buttonFooter);

        var countdown = buyButtons.querySelector(".new-product-countdown");
        // Re-appending an existing child moves it to the last position —
        // i.e. after <product-form-component>/the button, instead of
        // before it.
        if (countdown) buyButtons.appendChild(countdown);
    }

    // How many consecutive polling ticks getKachingAnchor()'s innerHTML has
    // to stay byte-identical before we consider Kaching "done" rendering —
    // see the readiness check inside relocatePopupContent() below.
    var KACHING_STABLE_TICKS_REQUIRED = 3;

    // Moves the reminder+selector container, the real Kaching widget, the
    // benefits block (".new-benefits-section", static/non-interactive —
    // see blocks/new-product-benefits.liquid) and the real
    // buy-buttons-block into the popup shell. Runs once.
    //
    // 2026-08-06 fix: discount badges and "Je bespaart .../gratis .../..."
    // highlight bullets were reported missing on bars once inside the
    // popup, even though they showed fine on the same product's
    // inline/control widget. getDealBars().length > 0 only confirms the
    // deal-block *attribute* has data — Kaching can still be progressively
    // decorating each bar (badges, highlight bullets) in the DOM after
    // that; moving the widget the instant bars first appear could relocate
    // it mid-decoration. We now also wait for getKachingAnchor().innerHTML
    // to stop changing across a few ticks before treating it as done.
    //
    // (An earlier version of this fix also snapshotted/restored innerHTML
    // around the move itself, to guard against Kaching's connectedCallback
    // re-rendering on reconnect — moving a custom element to a new parent
    // unavoidably disconnects/reconnects it. That made the missing content
    // worse, not better: overwriting innerHTML re-parses whatever's nested
    // inside, which re-triggers <kaching-bundles-block>'s OWN
    // connectedCallback a second time — and that second reconnect is what
    // was re-asserting Kaching's own default bar selection after ours,
    // fighting reapplyActiveWeightSelection(). Removed; the stability wait
    // above was the part actually fixing the missing content.)
    function relocatePopupContent(container, popup) {
        if (!popup || popup.__kachingContentMoved) return;

        var body = popup.querySelector("[data-kaching-popup-body]");
        var footer = popup.querySelector("[data-kaching-popup-footer]");
        if (!body || !footer) return;

        var attempts = 0;
        var lastAnchorHtml = null;
        var stableTicks = 0;

        var interval = setInterval(function () {
            attempts += 1;

            var anchor = getKachingAnchor();
            var kachingBlock = getKachingBlock();
            var hasBars = !!(anchor && kachingBlock && getDealBars(kachingBlock).length);

            if (hasBars) {
                var currentHtml = anchor.innerHTML;
                if (currentHtml === lastAnchorHtml) {
                    stableTicks += 1;
                } else {
                    stableTicks = 0;
                    lastAnchorHtml = currentHtml;
                }
            }

            var ready = hasBars && stableTicks >= KACHING_STABLE_TICKS_REQUIRED;

            if (!ready && attempts < MAX_PLACEMENT_ATTEMPTS) return;

            clearInterval(interval);
            if (popup.__kachingContentMoved) return;
            popup.__kachingContentMoved = true;

            var benefits = document.querySelector(".new-benefits-section");
            var buyButtons = document.querySelector(".buy-buttons-block");

            body.appendChild(container);
            // The container never goes through placeContainer() in popup
            // mode (that's the inline-only path) — make sure it's visible
            // now that it lives inside the popup for good.
            container.hidden = false;

            if (anchor) body.appendChild(anchor);
            if (benefits) body.appendChild(benefits);

            if (buyButtons) {
                leaveBuyButtonsPlaceholder(buyButtons);
                footer.appendChild(buyButtons);
                rearrangeBuyButtonsForPopup(buyButtons, benefits);
            }

            reapplyActiveWeightSelection(container);
        }, PLACEMENT_RETRY_MS);
    }

    function openPopup() {
        var popup = buildPopup();
        if (!popup) return;

        popup.hidden = false;
        document.body.classList.add(POPUP_OPEN_BODY_CLASS);

        // Two nested rAFs: the first lets the browser paint the
        // just-unhidden popup in its resting (off-screen/scaled-down)
        // state, the second then adds .is-open to trigger the transition —
        // without this the browser can coalesce both style changes into
        // one frame and skip the animation entirely.
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                popup.classList.add("is-open");
                if (popup.__kachingUpdateScrollIndicator) popup.__kachingUpdateScrollIndicator();
            });
        });
    }

    function closePopup() {
        if (!popupEl) return;

        popupEl.classList.remove("is-open");
        document.body.classList.remove(POPUP_OPEN_BODY_CLASS);

        setTimeout(function () {
            if (popupEl) popupEl.hidden = true;
        }, POPUP_CLOSE_TRANSITION_MS);
    }

    // Called from bindCartPropertyInjector()'s fetch/XHR hooks once a
    // /cart/add request actually succeeds — closes the popup so it
    // doesn't sit open behind the cart drawer that opens on top of it.
    // Deliberately re-checks both conditions itself (not just calling
    // closePopup() directly) so it stays a safe no-op for control/baseline
    // visitors, where popupEl is never built, and if the popup is already
    // closed.
    function closePopupOnCartAdd() {
        if (popupEl && !popupEl.hidden) closePopup();
    }

    // Intercepts the sticky bar's "Kies je pakket" click in the capture
    // phase — runs before sections/product-information.liquid's own
    // bubble-phase listener for the same [data-scroll-to-product-
    // information] button, so stopImmediatePropagation() fully replaces
    // the default scroll-to-product behavior instead of running alongside
    // it. Doesn't touch that shared file: this listener is only ever bound
    // for a popup-mode visitor (see enterPopupMode below), so control-group
    // and every non-test product keep the original scroll behavior as-is.
    var stickyCtaOverrideBound = false;

    function bindStickyCtaOverride() {
        if (stickyCtaOverrideBound) return;
        stickyCtaOverrideBound = true;

        document.addEventListener(
            "click",
            function (event) {
                var button = event.target.closest(STICKY_CTA_SELECTOR);
                if (!button) return;

                event.preventDefault();
                event.stopImmediatePropagation();
                openPopup();
            },
            true
        );
    }

    // Popup-mode-only copy for the sticky "Kies je pakket" button — swaps
    // in "Start je routine →" and hides the cart icon that normally sits
    // in front of the label (see the .svg-wrapper.add-to-cart-icon rule in
    // the {% stylesheet %}). Scoped to the button via a class we add
    // ourselves, so this never touches sections/product-information.liquid
    // or any other product's sticky bar.
    var POPUP_CTA_TEXT = "Kies je pakket →";
    var POPUP_CTA_CLASS = "kaching-weight-popup-cta";

    function applyPopupCtaLabel() {
        var button = document.querySelector(STICKY_CTA_SELECTOR);
        if (!button) return;

        button.classList.add(POPUP_CTA_CLASS);

        var textEl = button.querySelector(".sticky-add-to-cart__scroll-button-text");
        if (textEl) textEl.textContent = POPUP_CTA_TEXT;
    }

    // Popup-mode-only copy for the sticky bar's desktop title area (2026-
    // 08-06 feedback):
    //  - .sticky-add-to-cart__title normally prints product.metafields.
    //    product.short_title as-is, emoji/pack-info suffix included (e.g.
    //    "Anti-Jeuk Probiotica Forte 🌿 100% natuurlijk 📦 60 snoepjes") —
    //    swapped here for the same already-cleaned-up short title this
    //    widget itself uses (see kaching_weight_sync_short_title in the
    //    snippet, exposed via the container's data-short-title attribute
    //    so we don't have to re-implement that parsing in JS).
    //  - Adds a checkmark + "60 dagen geld-terug-garantie" line under the
    //    title. We build a *new* element instead of reusing/moving the
    //    existing .sticky-add-to-cart__info-mobile (same text, but that
    //    one's the mobile-only line — see sections/product-information.
    //    liquid's own CSS, .sticky-add-to-cart__info is display:none under
    //    768px). Leaving that original alone keeps mobile's current
    //    behavior exactly as-is; this new line lives inside
    //    .sticky-add-to-cart__info, so it naturally inherits the same
    //    hide-under-768px rule and only ever shows on desktop.
    //  - The existing mobile-only line (.sticky-add-to-cart__info-mobile,
    //    same "60 dagen geld-terug-garantie" text, shown under 768px while
    //    the image/title above are hidden) gets the same checkmark
    //    prepended in place — see addPopupGuaranteeCheckmark() below.
    var POPUP_GUARANTEE_TEXT = "60 dagen geld-terug-garantie";
    var POPUP_GUARANTEE_CLASS = "kaching-weight-popup-guarantee";
    var POPUP_GUARANTEE_CHECKMARK_SVG =
        '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M12.3972 0.729004L4.37631 8.89571L0.730469 5.18357" stroke="#069259" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>";

    function applyPopupStickyInfo(container) {
        var titleEl = document.querySelector(".sticky-add-to-cart__title");
        var shortTitle = container.getAttribute("data-short-title");
        if (titleEl && shortTitle) titleEl.textContent = shortTitle;

        var info = document.querySelector(".sticky-add-to-cart__info");
        if (info && !info.querySelector("." + POPUP_GUARANTEE_CLASS)) {
            var guarantee = document.createElement("p");
            guarantee.className = POPUP_GUARANTEE_CLASS;
            // JC_DO_PDP_COPY_01: reuse the server-rendered mobile line, which the
            // variant template's copy_replacements may have rewritten (90 dagen).
            // Control renders the same string as POPUP_GUARANTEE_TEXT.
            var mobileLine = document.querySelector(".sticky-add-to-cart__info-mobile");
            var guaranteeText = (mobileLine && mobileLine.textContent.trim()) || POPUP_GUARANTEE_TEXT;
            guarantee.innerHTML = POPUP_GUARANTEE_CHECKMARK_SVG + "<span>" + guaranteeText + "</span>";
            info.appendChild(guarantee);
        }

        addPopupGuaranteeCheckmark();
    }

    // Prepends the same checkmark to the mobile-only guarantee line
    // in-place, instead of building a separate element like
    // applyPopupStickyInfo() does for desktop — .sticky-add-to-cart__info-
    // mobile is the one actually visible under 768px, so there's nothing
    // to duplicate here, just decorate.
    var POPUP_GUARANTEE_MOBILE_CLASS = "kaching-weight-popup-guarantee-mobile";

    function addPopupGuaranteeCheckmark() {
        var infoMobile = document.querySelector(".sticky-add-to-cart__info-mobile");
        if (!infoMobile || infoMobile.classList.contains(POPUP_GUARANTEE_MOBILE_CLASS)) return;

        infoMobile.classList.add(POPUP_GUARANTEE_MOBILE_CLASS);
        infoMobile.innerHTML = POPUP_GUARANTEE_CHECKMARK_SVG + "<span>" + infoMobile.textContent.trim() + "</span>";
    }

    // Permanent marker for "this visitor is in popup mode" — unlike
    // POPUP_OPEN_BODY_CLASS (only present while the popup itself is open),
    // this stays on <body> the whole visit. Lets the {% stylesheet %} keep
    // the sticky "Start je routine →" bar visible everywhere on the page
    // (2026-08-06 feedback: it was hiding over the footer and while still
    // inside product-information, per sections/product-information.liquid's
    // own show/hide-by-scroll-position script — not something we touch).
    var POPUP_MODE_BODY_CLASS = "kaching-weight-popup-mode";

    // Popup-mode entry point (2026-08 v3 test) — kept defined but
    // deliberately unused by the current card test: "el popup queda
    // descartado para esta versión" — activate() below now calls
    // enterCardExperiment() instead. Left in place rather than deleted in case a
    // future test revisits the popup; this folder isn't git-tracked, so
    // there'd be no way to recover it if removed outright. Safe to leave
    // dormant — nothing here runs unless something calls enterPopupMode()
    // directly, which nothing does anymore.
    function enterPopupMode(container) {
        ensureBaseSetup(container);
        document.body.classList.add(POPUP_MODE_BODY_CLASS);

        var popup = buildPopup();
        if (!popup) return;

        relocatePopupContent(container, popup);
        bindStickyCtaOverride();
        applyPopupCtaLabel();
        applyPopupStickyInfo(container);
    }

    // Card-experiment entry point: inline placement next to
    // <kaching-bundle>, no popup —
    // plus cardExperimentActive = true so applyWeightPresentation()'s poll loop starts
    // applying the bar visibility window (see applyBarVisibilityWindow
    // above) on top of the usual bar selection/subtitle/banner work.
    // schedulePlacementAndScroll() is what actually un-hides/positions the
    // container (reminder + weight selector + labels) — easy to forget
    // since v3's enterPopupMode() deliberately skipped it (that mode moved
    // the container into the popup instead), but this experiment stays inline.
    // reapplyActiveWeightSelection()
    // re-runs the weight poll immediately against whatever bracket is
    // already active, so the bar window applies right away instead of
    // waiting for the next click.
    function enterCardExperiment(container, arm) {
        activeExperimentArm = arm;
        cardExperimentActive = true;
        document.body.classList.toggle("kaching-weight-card-coverage", arm === ARM_COVERAGE);
        document.body.classList.toggle("kaching-weight-card-price-led", arm === ARM_PRICE_LED);
        document.body.setAttribute("data-kaching-weight-test-arm", arm);
        ensureBaseSetup(container);
        schedulePlacementAndScroll(container);
        reapplyActiveWeightSelection(container);

        var observerAttempts = 0;
        var observerInterval = setInterval(function () {
            observerAttempts += 1;
            bindExperimentObserver(container);
            if (experimentObserver || observerAttempts >= MAX_PLACEMENT_ATTEMPTS) clearInterval(observerInterval);
        }, PLACEMENT_RETRY_MS);
    }

    // Single entry point for "this visitor is in the test variant" —
    // Intelligems' variant custom code or the arm-specific QA override. See
    // boot(): called either immediately (activation already queued/QA'd
    // before this script ran) or later after boot.
    function activate(requestedArm) {
        if (activated) return true;

        var container = document.querySelector("[data-kaching-weight-sync]");
        if (!container) return false;

        var qaArm = getQaArm();
        var arm = qaArm || normalizeExperimentArm(requestedArm) || ARM_COVERAGE;

        activated = true;
        enterCardExperiment(container, arm);

        return true;
    }

    function boot() {
        var container = document.querySelector("[data-kaching-weight-sync]");
        if (!container) return;

        applyCourseDaysOverride(container);
        bindProductFormVariantGuard();

        // The inline stub in kaching-weight-sync.liquid may have already
        // received an activate() call before this script ran — check its
        // flag before replacing the stub with the real implementation.
        var queuedExperiment =
            window.DogsuppyExperiments &&
            window.DogsuppyExperiments.kachingWeightSync &&
            window.DogsuppyExperiments.kachingWeightSync._queued
                ? window.DogsuppyExperiments.kachingWeightSync
                : null;
        var wasQueued = !!queuedExperiment;
        var queuedArm = queuedExperiment && queuedExperiment._queuedArm;

        window.DogsuppyExperiments = window.DogsuppyExperiments || {};
        window.DogsuppyExperiments.kachingWeightSync = {
            activate: activate,
            activateCoverage: function () { return activate(ARM_COVERAGE); },
            activatePriceLed: function () { return activate(ARM_PRICE_LED); },
            getVariantGuardState: function () {
                return {
                    stableTicks: kachingConfigStableTicks,
                    requiredStableTicks: KACHING_CONFIG_STABLE_TICKS_REQUIRED,
                    repairs: repairedKachingVariantIds.slice(),
                    formRepairs: repairedFormVariantIds.slice()
                };
            },
            intelligemsEnabled: true
        };

        // If we already know this visitor is in a card treatment, activate it
        // before falling back to control. Real
        // Intelligems timing matters here: for this to actually fire this
        // early, the variant's JS injection needs to run early enough for
        // its activate() call to reach the stub before boot() does (same
        // reasoning as the original test — see the QA_QUERY_PARAM note at
        // the top of this file). A later activate() call still works, it
        // just means the inline widget was briefly visible first.
        var qaArm = getQaArm();
        if (qaArm || wasQueued) {
            activate(qaArm || queuedArm);
        } else {
            runV4Baseline(container);
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", boot);
    } else {
        boot();
    }

    document.addEventListener("shopify:section:load", boot);
})();
// ============================================================
// KACHING WEIGHT SYNC EXPERIMENT — END
// ============================================================
